export const lg_listroom1 = {
  listroom1_th: {
    title: "รายการห้องประชุมของคุณ",
    title_remark:
      "ผู้ที่มีสิทธิ์ปิดห้องประชุม คือ ผู้ที่สร้างห้องและผู้ดูแลระบบเท่านั้น",
    room_search: "ค้นหา...",
    room_name: "ชื่อห้อง : ",
    room_id: "รหัสห้อง : ",
    room_user: "ผู้สร้าง : ",
    room_company: "บริษัท : ",
    room_department: "แผนก : ",
    room_date: "วันที่สร้าง : ",
    room_schedule: "กำหนดประชุม : ",
    room_record: "บันทึก : ",
    room_remark: "หมายเหตุ : ",
    room_record_detail: "เริ่มบันทึกเมื่อเริ่มประชุม",
    room_message_pass: "ห้องประชุมนี้มีรหัสผ่าน",
    room_lobby: "Waiting Room : ",
    room_message_lobby: "เปิดใช้งาน Lobby",
    btn_invite: "ส่งคำเชิญ",
    btn_join: "เข้าร่วม",
    btn_close: "ปิดการประชุม",
    titleMessageAlert: "ปิดห้องประชุม",
    messageAlert: "ท่านไม่ใช่ผู้สร้างห้องประชุม ไม่สามารถปิดได้",
    dialog_invite_title:
      "ใส่อีเมลของผู้เข้าร่วมเพื่อส่งลิงก์การประชุมโดยอัตโนมัติ",
    dialog_invite_send_to: "ใส่อีเมล...",
    dialog_invite_copy_link: "คัดลอกลิงก์",
    dialog_invite_copy_link_livestream: "คัดลอกลิงก์สตรีมสด (ในฐานะผู้ดู)",
    dialog_invite_send_link: "ส่งลิ้งค์",
    dialog_delete:
      "คุณแน่ใจหรือไม่ว่าต้องการลบห้องประชุมนี้? หากลบแล้วจะไม่สามารถย้อนกลับคืนได้",
    password: "รหัสผ่าน :",
    btn_join_livestream: "เข้าร่วมสตรีมสด",
    btn_send: "ส่ง",
    meet_option_verify_identify: "ยืนยันตัวตน",
    meet_sub__option_lobby:
      " เฉพาะผู้ใช้ที่ได้รับอนุญาตจากโฮสต์เท่านั้นจึงจะสามารถเข้าร่วมการประชุมได้",
    enter_sub_email:
      "ห้องประชุมนี้ต้องการ การยืนยัน OTP กรุณากรอกอีเมลของคุณเพื่อรับ OTP",
    require_sub_login: "ต้องยืนยันตัวตนเพื่อเข้าร่วมการประชุมนี้",
    require_sub_login2: "กรุณาเข้าสู่ระบบ Dmeets ก่อนเข้าร่วมการประชุม",
    more_info: "รายละเอียดการประชุม",
    delete_this_meeting: "ลบห้องประชุมนี้",
    create_new_meeting: "สร้างการประชุมใหม่",
    delete: "ลบ",
    cancel: "ยกเลิก",
    no_meeting_room: "ยังไม่มีการสร้างห้องประชุม",
    invitation_sent: "ส่งคำเชิญเรียบร้อยแล้ว",
    invitation_sent_details: "ลิงก์สำหรับเข้าร่วมประชุมถูกส่งเรียบร้อยแล้ว",
    close: "ปิด",
    lr_search_placeholder: "ค้นหาด้วยชื่อหรือรหัสการประชุม...",
    lr_col_meeting: "การประชุม",
    lr_col_dates: "วันที่",
    lr_col_settings: "การตั้งค่า",
    lr_col_actions: "การดำเนินการ",
    lr_created: "สร้างเมื่อ",
    lr_scheduled: "กำหนดการ",
    lr_status_live: "พร้อมประชุม",
    lr_status_scheduled: "กำหนดการ",
    lr_tag_otp: "ยืนยัน OTP",
    lr_tag_passcode: "ต้องใช้รหัสผ่าน",
    lr_tag_signin: "ต้องเข้าสู่ระบบ",
    lr_tag_record: "เริ่มบันทึกอัตโนมัติ",
    lr_tag_waiting: "ห้องรอ",
    lr_md_title: "รายละเอียดการประชุม",
    lr_md_meeting_id: "รหัสการประชุม",
    lr_md_schedule_date: "วันที่กำหนดประชุม",
    lr_md_schedule_time: "เวลาที่กำหนด",
    lr_md_created: "วันที่สร้าง",
    lr_md_owner: "เจ้าของการประชุม",
    lr_md_link: "ลิงก์การประชุม",
    lr_md_copy: "คัดลอก",
    lr_md_access: "การเข้าถึงและการตั้งค่า",
    lr_md_invitation: "คำเชิญ",
    lr_md_copy_invite: "คัดลอกคำเชิญ",
    lr_md_close_meeting: "ปิดการประชุม",
    lr_md_copy_link: "คัดลอกลิงก์",
    lr_md_join: "เข้าร่วมการประชุม",
  },
  listroom1_en: {
    title: "My meetings",
    title_remark:
      "Only the person who created the meeting or the system administrator has the rights to close the meeting.",
    room_search: "Search...",
    room_name: "Meeting Name : ",
    room_id: "Meeting ID : ",
    room_user: "Created by : ",
    room_company: "Company : ",
    room_department: "Department : ",
    room_date: "Created date : ",
    room_schedule: "Schedule : ",
    room_record: "Record : ",
    room_record_detail: "Record on start",
    room_remark: "Remark : ",
    room_message_pass: "This meeting room has a password",
    room_lobby: "Lobby : ",
    room_message_lobby: "Open Lobby",
    btn_invite: "Send Invitation",
    btn_join: "Join",
    btn_close: "Delete Meeting",
    titleMessageAlert: "Delete Meeting",
    messageAlert:
      "You are not the creator of the meeting room. You do not have the rights to close it.",
    dialog_invite_title:
      "Add the participant’s email to send them the meeting link directly.",
    dialog_invite_send_to: "Add email address...",
    dialog_invite_copy_link: "Copy meeting link",
    dialog_invite_copy_link_livestream: "Copy livestream (as viewer) link",
    dialog_invite_send_link: "Send link",
    dialog_delete:
      "Are you sure you want to delete this meeting room? You cannot undo this later.",
    password: "Password :",
    btn_join_livestream: "Join  Now as Livestream",
    btn_send: "Send",
    meet_option_verify_identify: "Verify user's identity",
    meet_sub__option_lobby:
      "Only users admitted by the host can join the meeting",
    enter_sub_email:
      "This meeting room requires OTP verification. Please enter your email to receive the OTP.",
    require_sub_login: "Authentication is required to join this meeting",
    require_sub_login2: "This meeting room requires logging into Dmeets",
    more_info: "More Information",
    delete_this_meeting: "Delete this meeting",
    create_new_meeting: "Create new meeting",
    delete: "Delete",
    cancel: "Cancel",
    no_meeting_room: "No meeting rooms created yet",
    invitation_sent: "Invitation Sent",
    invitation_sent_details:
      "Your meeting invite link has been sent successfully.",
    close: "Close",
    lr_search_placeholder: "Search by title or meeting ID...",
    lr_col_meeting: "Meeting",
    lr_col_dates: "Dates",
    lr_col_settings: "Settings",
    lr_col_actions: "Actions",
    lr_created: "Created",
    lr_scheduled: "Scheduled",
    lr_status_live: "Ready",
    lr_status_scheduled: "Scheduled",
    lr_tag_otp: "OTP verification",
    lr_tag_passcode: "Passcode protected",
    lr_tag_signin: "Sign-in required",
    lr_tag_record: "Record on start",
    lr_tag_waiting: "Waiting room",
    lr_md_title: "Meeting Details",
    lr_md_meeting_id: "Meeting ID",
    lr_md_schedule_date: "Scheduled Date",
    lr_md_schedule_time: "Scheduled Time",
    lr_md_created: "Created",
    lr_md_owner: "Host",
    lr_md_link: "Meeting Link",
    lr_md_copy: "Copy",
    lr_md_access: "Access & Settings",
    lr_md_invitation: "Invitation",
    lr_md_copy_invite: "Copy Invitation",
    lr_md_close_meeting: "Close Meeting",
    lr_md_copy_link: "Copy Link",
    lr_md_join: "Join Meeting",
  },
};
